
import { CheckCircle } from 'lucide-react';

interface TestimonialsSectionProps {
  visible: boolean;
}

const TestimonialsSection = ({ visible }: TestimonialsSectionProps) => {
  const testimonials = [
    {
      text: "The Holland Code assessment helped me find the perfect engineering path!",
      author: "Rahul, Kochi"
    },
    {
      text: "I planned my international studies confidently with expert RIASEC guidance!",
      author: "Aleena, Trivandrum"
    },
    {
      text: "Finally, a test that scientifically identifies my skills & suggests the right future!",
      author: "Arjun, Thrissur"
    },
    {
      text: "I discovered a high-paying career that perfectly matches my personality type!",
      author: "Nandita, Calicut"
    }
  ];

  return (
    <section className={`py-20 px-4 sm:px-6 md:px-8 transition-all duration-700 ease-in-out delay-600 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-blue mb-12">
          Success Stories & Testimonials
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-xl shadow-soft transition-all duration-300 hover:shadow-elevated"
              style={{ transitionDelay: `${index * 100 + 600}ms` }}
            >
              <div className="flex items-start">
                <CheckCircle className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-gray-700 mb-2">"{testimonial.text}"</p>
                  <p className="text-sm font-medium text-brand-blue">– {testimonial.author}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
